/* eslint-disable jsx-a11y/no-autofocus */
import { Formik, Form, Field } from 'formik';
import { Button, Input, Spinner } from '@crazyegginc/hatch';

import { useMutation, useModal } from '/src/hooks';
import { editFunnelNameMutation } from '../../mutations';
import { Modal } from '/src/contexts/modal';

export function RenameFunnelModal({ funnel, onSuccess }) {
  const modal = useModal();
  const renameFunnel = useMutation(editFunnelNameMutation);

  return (
    <Modal dialogClassName="!p-6 !w-[365px]">
      <Formik
        initialValues={{ name: funnel.name }}
        onSubmit={(values) => {
          renameFunnel.mutate(
            {
              name: values.name,
              id: funnel.id,
              siteId: funnel.siteId,
            },
            {
              onSuccess: (data) => {
                onSuccess?.(data.funnelEditName);
                modal.close();
              },
            },
          );
        }}
      >
        {({ values, dirty }) => (
          <Form>
            <Modal.Title>Rename your Funnel</Modal.Title>

            <Field name="name">{({ field }) => <Input {...field} autoFocus aria-label="Funnel name" />}</Field>

            <Modal.Actions>
              <Button type="submit" disabled={renameFunnel.isLoading || !values.name.trim() || !dirty}>
                {renameFunnel.isLoading && (
                  <span className="mr-2.5">
                    <Spinner />
                  </span>
                )}
                {renameFunnel.isLoading ? 'Renaming...' : 'Rename'}
              </Button>
              <Modal.Cancel />
            </Modal.Actions>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
